import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import loginPageSlice from "../../login-page/store/slice";
import cargoTypeSlice, { CargoType } from "./slice";

type CargoTypeResponse = ApiResponse<{ data: CargoType[] }>;

function* cargoTypeSaga() {
  yield takeLatest(loginPageSlice.actions.setLoggedIn, handleFetch);
}

function* handleFetch() {
  const response: CargoTypeResponse = yield call(fetchAPI, "/cargo-types");

  if (response && response.data) {
    yield put(cargoTypeSlice.actions.setData(response.data));
  }

  yield put(cargoTypeSlice.actions.setIsLoading(false));
}

export default cargoTypeSaga;
